import { render, staticRenderFns } from "./BaseTable.vue?vue&type=template&id=8c0fb7a2&scoped=true"
import script from "./BaseTable.vue?vue&type=script&lang=js"
export * from "./BaseTable.vue?vue&type=script&lang=js"
import style0 from "./BaseTable.vue?vue&type=style&index=0&id=8c0fb7a2&lang=scss&scoped=true"
import style1 from "./BaseTable.vue?vue&type=style&index=1&id=8c0fb7a2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0fb7a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\0.资料\\项目\\girdear_mall_center_web\\node_modules\\.store\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c0fb7a2')) {
      api.createRecord('8c0fb7a2', component.options)
    } else {
      api.reload('8c0fb7a2', component.options)
    }
    module.hot.accept("./BaseTable.vue?vue&type=template&id=8c0fb7a2&scoped=true", function () {
      api.rerender('8c0fb7a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/BaseTable.vue"
export default component.exports